/* eslint-disable import/no-anonymous-default-export */
import _ from 'lodash';

export default (state = true, action) => {

  if (
    ['SET_SORT_BY_QUALYS', 'ADD_FILTER_QUALYS', 'DELETE_FILTER_QUALYS', 'RESET_FILTERS_QUALYS'].includes(action.type)
  ) {
    return true;
  }

  if (
    ['SET_CVES_QUALYS'].includes(action.type)
  ) {
    return false;
  }

  return state;
};